export default {"src":"/_next/static/media/FilledStar.3999c816.svg","height":19,"width":20};